export const HANDLE_QUESTIONNAIRE_FORM_CHANGE = 'questionnaire/HANDLE_QUESTIONNAIRE_FORM_CHANGE';
export const QUESTIONNAIRE_VIEW = 'questionnaire/QUESTIONNAIRE_VIEW';
export const QUESTIONNAIRE_FORM_HAS_CHANGES = 'questionnaire/QUESTIONNAIRE_FORM_HAS_CHANGES';
export const QUESTIONNAIRE_NOT_FOUND = 'questionnaire/QUESTIONNAIRE_NOT_FOUND';
export const LOADING_QUESTIONNAIRES = 'questionnaire/LOADING_QUESTIONNAIRES';
export const OPEN_QUESTIONNAIRES = 'questionnaire/OPEN_QUESTIONNAIRES';